export default [
    {
        path: 'relatorio-dispensacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-dispensacao' */
            '@/views/farmacia/relatorio-dispensacao/Index'
        ),
        redirect: 'relatorio-dispensacao/index',
        children: [
            {
                name: 'farmacia-relatorio-dispensacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-dispensacao' */
                    '@/views/farmacia/relatorio-dispensacao/List.vue'
                ),
            },
        ],
    },
]